webpackJsonp([22540138088872],{

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Anatomy = __webpack_require__(10);
	
	var _Anatomy2 = _interopRequireDefault(_Anatomy);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Anatomy2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      '/config/collections.js'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This is the configuration file for ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore-hook-collections'
	      ),
	      ' and is where you define overrides for the default collection behaviors.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You can learn more about the configuration options ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/hooks/lore-hook-collections/' },
	        'here'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'While this file can influence the behavior of collections, there is currently no clear reason why you would ever need to use it.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'If you need to define collection specific behavior (such as parsing server responses or defining headers to add to requests) you should do that in ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/anatomy/config/connections/' },
	          '/config/connections.js'
	        ),
	        '.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'If you have multiple connections, and need to define which collections use each connection, you should do that in ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/anatomy/config/models/' },
	          '/config/models.js'
	        ),
	        ' as this file inherits that behavior.'
	      )
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Default Config'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default config is shown below.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      /**\n       * Configuration file for collections\n       *\n       * This file is where you define overrides for the default collection behaviors.\n       */\n\n      export default {\n\n        /**\n         * While this file can influence the behavior of collections, there is currently\n         * no clear reason why you would ever need to use it.\n         *\n         * If you need to define collection specific behavior (such as parsing server responses\n         * or defining headers to add to requests) you should do that in \'config/connections.js\'.\n         *\n         * If you have multiple connections, and need to define which collections use each\n         * connection, you should do that in \'config/models.js\' as this file inherits that\n         * behavior.\n         *\n         */\n\n      }\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-anatomy-config-collections-js-69968814e2fb140ddbcd.js